import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class CorrelationInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (request.url.startsWith('/assets')) {
      return next.handle(request);
    }

    const correlationId = crypto.randomUUID();
    return next.handle(request.clone({ headers: request.headers.set('X-Correlation-ID', correlationId) }));
  }
}
